interface SplitNumberResult {
    integerPart: string;
    fractionalPart: string;
}

export function splitNumber(value: number): SplitNumberResult {
    const [integerPart, fractionalPart = ''] = value.toString().split('.');

    return {
        integerPart,
        fractionalPart: fractionalPart.padEnd(2, '0').slice(0, 2),
    };
}
